import { OrderResource, orderTaskPermission } from 'model';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, Typography } from '@material-ui/core';
import { Close, GetApp, Info, Today } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { formatDate } from '../../../../localized-formats';
import { createFileGrant } from '../../../../utils';

export function OrderResourceDisplay({ value }: { value: OrderResource }) {
  const { t } = useTranslation();
  return (
    <div>
      <div style={{ display: 'inline-flex' }}>
        <Typography>{value?.name}</Typography>
      </div>
      <div style={{ paddingLeft: 10 }}>
        <Typography variant="subtitle1" color="textSecondary">
          <Info color="inherit" fontSize="inherit" style={{ marginRight: 2 }} />
          {value.description}
        </Typography>
        {value.state !== 'completed' && (
          <Typography
            variant="subtitle1"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Close
              color="error"
              fontSize="inherit"
              style={{ marginRight: 2 }}
            />

            {t('Not Available')}
          </Typography>
        )}
        {value.state !== 'completed' && value.estimatedDelivery && (
          <div style={{ display: 'flex' }}>
            <Today style={{ fontSize: 16 }} />
            <div style={{ paddingLeft: 2 }}>
              <Typography variant="caption" style={{ alignSelf: 'center' }}>
                available from:
              </Typography>
              <Typography>
                {formatDate(value.estimatedDelivery, 'date')}
              </Typography>
            </div>
          </div>
        )}
        {value.attachedFiles &&
          value.attachedFiles.map((af) => (
            <Chip
              size="small"
              component={RouterLink}
              to={`/files/${af.id}/${
                createFileGrant(af.id, orderTaskPermission, value).token
              }`}
              target="blank"
              label={
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center'
                  }}
                >
                  {af.name}
                  <GetApp
                    style={{ marginLeft: 4, fontSize: 14 }}
                    fontSize="small"
                    color="action"
                  />
                </div>
              }
            />
          ))}
      </div>
    </div>
  );
}
